import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const TimelineBox = () => {
	const block = document.querySelectorAll(".timeline-box");
	if (!block) {
		return;
	}
	gsap.registerPlugin(ScrollTrigger);
	let mm = gsap.matchMedia();

	block.forEach((el) => {
		const items = el.querySelectorAll(".timeline-box__item");

		mm.add("(min-width: 768px)", () => {
			items.forEach((item, index) => {
				const title = item.querySelector(".timeline-box__title");

				const TLShow = gsap.timeline({
					scrollTrigger: {
						trigger: item,
						start: "top 90%",
						end: `+=${window.innerHeight * 0.9}px`,
						scrub: true
					}
				})
				TLShow.to(item, { y: 0, opacity: 1, ease: "none", duration: 1 }, 0);
				TLShow.to(item, { opacity: 0, ease: "none", duration: 1 }, 1);

				TLShow.to(title, { x: 0, scale: 1, ease: "none", duration: 1 }, 0);
				TLShow.to(title, { x: 10, scale: 0.8, ease: "none", duration: 1 }, 1);
			});
		});
	});
};

export default TimelineBox;
